<template>
  <div class="container-fluid overflow-auto page-container-h">
    <section class="deactivate-membership-area">
      <b-card
        class="text-center"
        header-bg-variant="secondary"
        header-text-variant="white"
      >
        <template #header>
          <div>{{ stopMembership.lastMonth.title }}</div>

          <div>{{ stopMembership.lastMonth.subtitle }}</div>
        </template>

        <template v-if="stopMembership.lastMonth.data.length > 0">
          <ul>
            <li v-for="(item, index) in stopMembership.lastMonth.data" :key="index">
              {{ item.number }} {{ item.member_name }}
            </li>
          </ul>
        </template>

        <template v-else>
          <div class="no-data">查無此資料!!</div>
        </template>
      </b-card>

      <b-card
        class="text-center"
        header-bg-variant="danger"
        header-text-variant="white"
      >
        <template #header>
          <div>{{ stopMembership.thisMonth.title }}</div>

          <div>{{ stopMembership.thisMonth.subtitle }}</div>
        </template>

        <template v-if="stopMembership.thisMonth.data.length > 0">
          <ul>
            <li v-for="(item, index) in stopMembership.thisMonth.data" :key="index">
              {{ item.number }} {{ item.member_name }}
            </li>
          </ul>
        </template>

        <template v-else>
          <div class="no-data">查無此資料!!</div>
        </template>
      </b-card>

      <b-card
        class="text-center"
        header-bg-variant="success"
        header-text-variant="white"
      >
        <template #header>
          <div>{{ stopMembership.nextMonth.title }}</div>

          <div>{{ stopMembership.nextMonth.subtitle }}</div>
        </template>

        <template v-if="stopMembership.nextMonth.data.length > 0">
          <ul>
            <li v-for="(item, index) in stopMembership.nextMonth.data" :key="index">
              {{ item.number }} {{ item.member_name }}
            </li>
          </ul>
        </template>

        <template v-else>
          <div class="no-data">查無此資料!!</div>
        </template>
      </b-card>
    </section>

    <section class="payment-area">
      <b-card
        class="text-center"
        header-bg-variant="warning"
        header-text-variant="white"
      >
        <template #header>
          <div>{{ payment.inProgress.title }}</div>
        </template>

        <template v-if="payment.inProgress.data.length > 0">
          <ul>
            <li v-for="(item, index) in payment.inProgress.data" :key="index">
              {{ item.number }} {{ item.member_name }}：{{ getRocYearAndMonthOfPeriod(item.behalf_at) }} ~ {{ getRocYearAndMonthOfPeriod(item.behalf_end) }}
            </li>
          </ul>
        </template>

        <template v-else>
          <div class="no-data">查無此資料!!</div>
        </template>
      </b-card>

      <b-card
        class="text-center"
        header-bg-variant="info"
        header-text-variant="white"
      >
        <template #header>
          <div>{{ payment.behalfDebt.title }}</div>
        </template>

        <template v-if="payment.behalfDebt.data.length > 0">
          <ul>
            <li v-for="(item, index) in payment.behalfDebt.data" :key="index">
              {{ item.number }} {{ item.member_name }}：{{ item.behalf_history_view }}
            </li>
          </ul>
        </template>

        <template v-else>
          <div class="no-data">查無此資料!!</div>
        </template>
      </b-card>
    </section>
  </div>
</template>

<script>

import contractApi from "@/models/API/contractApi";
import { convertRocDate, getRocYearAndMonthOfPeriod } from "@/models/HELPERS/common.js";

export default {
  name: 'dashboard',
  components: {


  },
  data () {
    return {
      search: {
        pay_date_S: '',
        pay_date_E: ''
      },
      status: {

      },
      data: {

      },
      stopMembership: {
        lastMonth: {
          month_trends: -1,
          api_params: {
            'last_stop': 1
          },
          title: '上個月',
          subtitle: '',
          data: []
        },
        thisMonth: {
          month_trends: 0,
          api_params: {
            'now_stop': 1
          },
          title: '這個月',
          subtitle: '',
          data: []
        },
        nextMonth: {
          month_trends: +1,
          api_params: {
            'next_stop': 1
          },
          title: '下個月',
          subtitle: '',
          data: []
        }
      },
      payment: {
        inProgress: {
          month_trends: 0,
          api_params: {
            'status': 4
          },
          title_prefix: '墊繳中會員',
          title: '',
          data: []
        },
        behalfDebt: {
          month_trends: 0,
          api_params: {
            'behalf_debt': 1
          },
          title_prefix: '墊繳到期未還款會員',
          title: '',
          data: []
        }
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    getRocYearAndMonthOfPeriod,
    // 首次載入讀取
    load() {
      this.stopMembershipTitleHandler();
      this.paymentTitleHandler();
    },
    // 停效會員標題處理
    async stopMembershipTitleHandler() {
      for (const [key, value] of Object.entries(this.stopMembership)) {
        const today = new Date();
        today.setMonth(today.getMonth() + value.month_trends);
        const {year, month} = convertRocDate(today, false, true);

        value.subtitle = `停效到期會員${year}-${month}`

        const res = await this.getMember(value.api_params);

        value.data = res;
      }
    },
    // 墊繳標題處理
    async paymentTitleHandler() {
      for (const [key, value] of Object.entries(this.payment)) {
        const today = new Date();
        today.setMonth(today.getMonth() + value.month_trends);
        const {year, month} = convertRocDate(today, false, true);

        value.title = `${value.title_prefix}${year}-${month}`

        const res = await this.getMember(value.api_params);

        value.data = res;
      }
    },
    // 查詢契約
    getMember(params) {
      return new Promise((resolve, reject) => {
        this.contractApi.getMember((response) => {
          const res = response.data;
          const complete_format = res.data.map(item => {
            return {
              ...item,
              behalf_history_view: this.behalfHistoryDataHandler(item.behalf_history)
            }
          });

          resolve(complete_format);
        }, params)
      })
    },
    // 歷史墊繳資料處理
    behalfHistoryDataHandler(data) {
      if (!data) return '';

      const list = data.split(',');
      const complete_format = list.map(item => {
        const start_date = item.split('~')[0];
        const end_date = item.split('~')[1];

        return `${getRocYearAndMonthOfPeriod(start_date)} ~ ${getRocYearAndMonthOfPeriod(end_date)}`
      }).join(',');

      return complete_format;
    }
  }
}
</script>

<style lang="scss" scoped>
.deactivate-membership-area {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
  .card-body {
    padding: 10px;
    font-size: 18px;
    ul {
      padding-left: 0;
      margin-bottom: 0;
      li {
        list-style: none;
      }
    }
    .no-data {
      height: 100%;
      color: red;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.payment-area {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
  .card-body {
    padding: 10px;
    font-size: 18px;
    ul {
      padding-left: 0;
      margin-bottom: 0;
      li {
        list-style: none;
      }
    }
    .no-data {
      height: 100%;
      color: red;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/dashboard.vue